<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form
        :model="where"
        label-width="77px"
        class="ele-form-search"
        @keyup.enter.native="reload"
        @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="用户名称">
              <el-select v-model="where.username" clearable filterable class="ele-block" placeholder="请选择">
                <el-option
                  v-for="item in userList"
                  :key="item.id"
                  :value="item.id"
                  :label="item.username" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="系统订单">
              <el-input clearable v-model.trim="where.orderNo" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="交易类型">
              <el-select clearable class="ele-block" v-model="where.type" placeholder="请选择">
                <el-option
                  v-for="item in typeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="10" :md="12">
            <el-form-item label="选择时间">
              <el-date-picker
                v-model="where.time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
              <el-button type="danger" icon="el-icon-document" size="small" class="ele-btn-icon" @click="onExportClick"
                v-if="permission.includes('sys:records:index')">导出</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>

      <ele-pro-table
        ref="table"
        :where="where"
        :datasource="url"
        :columns="columns"
        :page-size="20"
        height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="warning" icon="el-icon-refresh" class="ele-btn-icon" @click="initData"
            v-if="permission.includes('sys:records:index')">
            初始化
          </el-button>
        </template>
      </ele-pro-table>
    </el-card>

    <export-progress-dialog ref="exportDialog" biz="records" title="导出资金变动" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ExportProgressDialog from '@/components/ExportProgressDialog.vue';
import { getDictData } from '@/utils/dict';

export default {
  name: 'TransactionRecords',
  components: { ExportProgressDialog },
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/UserBalancesRecords/index',
      columns: [
        { prop: 'id', label: '序号', width: 60, align: 'center', showOverflowTooltip: true, fixed: 'left' },
        { prop: 'username', label: '用户名称', fixed: 'left', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'order_no', label: '系统订单', showOverflowTooltip: true, minWidth: 200, align: 'center' },
        { prop: 'type', label: '交易类型', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'before_money', label: '变动前', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'money', label: '变动金额', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'after_money', label: '余额', showOverflowTooltip: true, minWidth: 100, align: 'center' },
        { prop: 'remark', label: '内容', showOverflowTooltip: true, minWidth: 400, align: 'left' },
        {
          prop: 'update_time',
          label: '更新时间',
          showOverflowTooltip: true,
          minWidth: 170,
          align: 'center',
          formatter: (row, column, cellValue) => this.$util.toDateString(cellValue)
        }
      ],
      where: {},
      userList: [],
      typeOptions: []
    };
  },
  mounted() {
    this.loadTypeOptions();
    this.getUserList();
  },
  methods: {
    reload() {
      this.$refs.table.reload({ where: this.where });
    },
    reset() {
      this.where = {};
      this.reload();
    },
    onExportClick() {
      this.$refs.exportDialog.start({ ...this.where });
    },
    initData() {
      this.$confirm('初始化将清空全部资金变动且不可恢复，确定继续？', '提示', {
        type: 'warning',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        const loading = this.$loading({ lock: true });
        this.$http.post('/UserBalancesRecords/initData').then((res) => {
          loading.close();
          if (res.data.code === 0) {
            this.$message.success(res.data.msg);
            this.reload();
          } else {
            this.$message.error(res.data.msg);
          }
        }).catch((e) => {
          loading.close();
          this.$message.error(e.message);
        });
      }).catch(() => {});
    },
    loadTypeOptions() {
      getDictData('user_balance_type')
        .then((list) => {
          this.typeOptions = (list || []).map((item) => ({
            value: item.dictDataCode,
            label: item.dictDataName
          }));
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    getUserList() {
      this.$http.get('/UserBalancesRecords/getUserList').then((res) => {
        if (res.data.code === 0) {
          this.userList = res.data.data || [];
        } else {
          this.$message.error(res.data.msg);
        }
      }).catch((e) => {
        this.$message.error(e.message);
      });
    }
  }
};
</script>
